import React from 'react'

import './Loader.scss'

const Loader = ({ style }) => {
  return (
    <div className="scrollBlock" style={style}>
      <div className="text">TIME suburbs</div>
      <div className="top"></div>
      <div className="bot"></div>
    </div>
  )
}

export default Loader
